import {Navigate} from "react-router-dom";
import {SavedLocation} from "./SavedLocation";
import {XSRF} from "./Xsrf";

/**
 * The Success function redirects the user to a previously saved location upon successful authentication.
 * If no saved location exists in local storage, it defaults to the root path ("/").
 * The function uses the Navigate component to handle the redirection.
 *
 * @returns {JSX.Element} A JSX element containing the Navigate component, which performs the redirection.
 */
export const Success = () =>
{
    return (
        <div>
            {XSRF.generateCookie()}
            <Navigate to={SavedLocation.getSavedLocation()??"/"}/>
        </div>
    )
}